type AdminTablePaginationProps = {
  page: number;
  totalItems: number;
  pageSize?: number;
  onPageChange: (page: number) => void;
  itemLabel: string;
};

function pageNumbers(page: number, totalPages: number) {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);
  const pages = new Set([1, totalPages, page, page - 1, page + 1]);
  if (page <= 3) [2, 3, 4].forEach((value) => pages.add(value));
  if (page >= totalPages - 2) [totalPages - 3, totalPages - 2, totalPages - 1].forEach((value) => pages.add(value));
  return [...pages].filter((value) => value > 0 && value <= totalPages).sort((a, b) => a - b);
}

export default function AdminTablePagination({ page, totalItems, pageSize = 10, onPageChange, itemLabel }: AdminTablePaginationProps) {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const pages = pageNumbers(page, totalPages);
  if (totalItems <= pageSize) return null;

  return (
    <nav className="flex flex-wrap items-center justify-end gap-1 pb-2.5" aria-label={`${itemLabel} pagination`}>
      <button type="button" className="rounded px-2 py-1 text-xs hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-40" onClick={() => onPageChange(Math.max(1, page - 1))} disabled={page === 1} aria-label={`Previous ${itemLabel} page`}>‹ <span className="hidden sm:inline">Previous</span></button>
      {pages.map((pageNumber, index) => {
        const previous = pages[index - 1];
        return (
          <span key={pageNumber} className="contents">
            {previous && pageNumber - previous > 1 ? <span className="px-1 text-xs" aria-hidden="true">…</span> : null}
            <button type="button" className={`min-w-7 rounded px-2 py-1 text-xs ${pageNumber === page ? 'bg-blue-600 text-white' : 'hover:bg-slate-800'}`} onClick={() => onPageChange(pageNumber)} aria-label={`Page ${pageNumber}`} aria-current={pageNumber === page ? 'page' : undefined}>{pageNumber}</button>
          </span>
        );
      })}
      <button type="button" className="rounded px-2 py-1 text-xs hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-40" onClick={() => onPageChange(Math.min(totalPages, page + 1))} disabled={page === totalPages} aria-label={`Next ${itemLabel} page`}><span className="hidden sm:inline">Next</span> ›</button>
    </nav>
  );
}
